import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator, httpsCallable } from 'firebase/functions';

/* Which Firebase project this build talks to (2026-10-08).
 *
 * Production (`pear`) unless REACT_APP_FIREBASE_ENV=test was set when the build
 * was made — then the TEST project (`trasse-test`), which has its own database,
 * logins, rules and function, and no real schools in it. The choice is baked in
 * at build time like every other REACT_APP_ value: the test site on Render sets
 * it, and a local run is `REACT_APP_FIREBASE_ENV=test npm start`.
 *
 * These are web app identifiers, not secrets: they are in every page the
 * browser loads. What protects the data is the rules, not these strings. */
const PRODUCTION = {
  apiKey: "AIzaSyD19gsjNedDbsoNTJBH4Izsrs3J-0TzzLE",
  authDomain: "pear-bc51f.firebaseapp.com",
  projectId: "pear-bc51f",
  storageBucket: "pear-bc51f.firebasestorage.app",
  messagingSenderId: "124064044162",
  appId: "1:124064044162:web:d021f05cc52b1ce0a7509b"
};

const TEST = {
  apiKey: "AIzaSyDfofEJvloHPy2HVRIk4ifEqUZ2OIRzt9c",
  authDomain: "trasse-test.firebaseapp.com",
  projectId: "trasse-test",
  storageBucket: "trasse-test.firebasestorage.app",
  messagingSenderId: "685089286521",
  appId: "1:685089286521:web:2fb2416c9241641085e7a8"
};

export const FIREBASE_ENV: 'production' | 'test' =
  process.env.REACT_APP_FIREBASE_ENV === 'test' ? 'test' : 'production';

const firebaseConfig = FIREBASE_ENV === 'test' ? TEST : PRODUCTION;

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

/** Callables deployed with `region: "europe-west1"` (see pear_mobile/functions). */
export const functionsEu = getFunctions(app, 'europe-west1');

if (
  process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true' &&
  typeof window !== 'undefined'
) {
  connectFunctionsEmulator(functionsEu, '127.0.0.1', 5001);
}

export { httpsCallable };

export default app;
